"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.about = void 0;
exports.about = {
    about_title: "О проекте",
    about_name: "РСО.НАВИГАТОР",
    about_text1: "“РСО.Навигатор” бесплатное и доступное приложение созданное для людей, которые хотят внедрить раздельный сбор отходов в городе.",
    about_text2: "Здесь собрана единая база мест приема вторсырья, специализированных контейнеров для сбора различных фракций, а также пунктов приема отходов I и II классов опасности. Раздельный сбор отходов (РСО) является приоритетной задачей национального проекта «Экология» в России.",
    about_text3: "Приложение поможет жителям г. Иваново и Ивановской области максимально извлечь полезные фракции из бытовых отходов. В приложении собрана информация",
    about_list1: "об инфраструктуре для раздельного сбора отходов в местах их накопления (отдельные контейнеры для утилизируемых отходов на контейнерных площадках);",
    about_list2: "о пунктах приема вторсырья, где можно сдать полезные фракции;",
    about_list3: "о местах приема опасных отходов у населения (батарейки, аккумуляторы, электронное оборудование, бытовая техника, ртутьсодержащие лампы и тд);",
    about_list4: "новости о различных экологических акциях и мероприятиях, организуемых экоактивистами и специализированными организациями.",
    about_feedback: "Обратная связь",
    about_creators: "Приложение создано ",
    about_creatorsLink: 'Ивановским областным отделением "Всероссийским обществом охраны природы"',
    about_vk: "Мы Вконтакте",
    about_pgLogoAlt: "При поддержке Фонда президентских грантов",
};
//# sourceMappingURL=about.js.map